export default "__VITE_ASSET__CQqNX73p__"